"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.API = void 0;
const axios_1 = __importDefault(require("axios"));
class API {
    constructor() {
        this.bearerToken = process.env.LETS_TRADE_ROOT_TOKEN;
        this.getLoader = () => {
            return document.getElementById("loader");
        };
        this.loaderHide = () => {
            const loader = this.getLoader();
            if (loader) {
                loader.classList.remove("flex");
                loader.classList.add("hidden");
            }
        };
        this.loaderShow = () => {
            const loader = this.getLoader();
            if (loader) {
                loader.classList.remove("hidden");
                loader.classList.add("flex");
            }
        };
    }
    apiGet({ baseUrl, endpoint, contentType, authorization, customHeaders, loader = true }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (loader)
                this.loaderShow();
            return yield (0, axios_1.default)({
                method: "GET",
                url: `${baseUrl}/${endpoint}`,
                headers: this.getHeaders({ authorization, contentType, customHeaders }),
            })
                .then((response) => {
                this.loaderHide();
                return response.data;
            })
                .catch((error) => {
                this.loaderHide();
                return this.extractErrorMessage(error);
            });
        });
    }
    apiPost({ baseUrl, endpoint, contentType, content, authorization, customHeaders, loader = true }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (loader)
                this.loaderShow();
            return yield (0, axios_1.default)({
                method: "POST",
                url: `${baseUrl}/${endpoint}`,
                headers: this.getHeaders({ authorization, contentType, customHeaders }),
                data: content,
            })
                .then((response) => {
                this.loaderHide();
                return response.data;
            })
                .catch((error) => {
                this.loaderHide();
                return this.extractErrorMessage(error);
            });
        });
    }
    apiPut({ baseUrl, endpoint, contentType, content, authorization, customHeaders, loader = true }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (loader)
                this.loaderShow();
            return yield (0, axios_1.default)({
                method: "PUT",
                url: `${baseUrl}/${endpoint}`,
                headers: this.getHeaders({ authorization, contentType, customHeaders }),
                data: content,
            })
                .then((response) => {
                this.loaderHide();
                return response.data;
            })
                .catch((error) => {
                this.loaderHide();
                return this.extractErrorMessage(error);
            });
        });
    }
    apiDelete({ baseUrl, endpoint, contentType, content, authorization, customHeaders }) {
        return __awaiter(this, void 0, void 0, function* () {
            this.loaderShow();
            return yield (0, axios_1.default)({
                method: "DELETE",
                url: `${baseUrl}/${endpoint}`,
                headers: this.getHeaders({ authorization, contentType, customHeaders }),
                data: content,
            })
                .then((response) => {
                this.loaderHide();
                return response.data;
            })
                .catch((error) => {
                this.loaderHide();
                return this.extractErrorMessage(error);
            });
        });
    }
    getHeaders(params) {
        var _a, _b;
        let objHeaders = {};
        objHeaders["content-type"] = (_a = params.contentType) !== null && _a !== void 0 ? _a : "application/json";
        if (params.authorization) {
            objHeaders.authorization = `Bearer ${(_b = params.authorization) !== null && _b !== void 0 ? _b : this.bearerToken}`;
        }
        if (params.customHeaders) {
            objHeaders = Object.assign(Object.assign({}, objHeaders), params.customHeaders);
        }
        return objHeaders;
    }
    extractErrorMessage(error) {
        var _a, _b, _c, _d;
        let message = error;
        if ((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) {
            message = (_d = (_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message;
        }
        else if (error === null || error === void 0 ? void 0 : error.message) {
            message = error === null || error === void 0 ? void 0 : error.message;
        }
        else if (error.response) {
            // The client was given an error response (5xx, 4xx)
            if (error.response.status == 0) {
                message = "Client could not connect to the server";
            }
            else {
                message = "Client was given an error response";
            }
            // message = "Client was given an error response";
        }
        else if (error.request) {
            message = "Client request never left the browser and therefore never received a response from the server ";
        }
        else {
            // Anything else
            message = "Client was given an error response";
        }
        //Simulate a normal response so that it wont break the UI.
        return {
            success: false,
            message: message,
            content: error,
        };
    }
}
exports.API = API;
